import { setSpecificMessage, cuid2 } from "valibot";
setSpecificMessage(
  cuid2,
  (issue) => `Cuid2 invalide: reçu ${issue.received}`,
  "fr"
);